module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"no-access-title":"Vous n\u0027avez pas d\u0027accès suffisant","please-connect":"Veuillez-vous connecter pour accéder à cette partie du site.","connect-label":"Se connecter"},"de":{"no-access-title":"Sie haben keinen ausreichenden Zugriff","please-connect":"Bitte einlogge Sie sich, um auf diesen Teil der Website zuzugreifen.","connect-label":"Einloggen"}}')
  delete Component.options._Ctor
}
